/* RW7 2026-10-02 (staging): quick size finder. Pairs with sections/rww-quick-finder.liquid. */
(function () {
  'use strict';
  function val(s) {
    var w = 0, m = String(s).match(/^(\d+)-(\d+\/\d+)$/);
    if (m) { w = +m[1]; s = m[2]; }
    if (String(s).indexOf('/') > -1) { var p = s.split('/'); return w + p[0] / p[1]; }
    return w + (+s);
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function store(k, v) { try { if (v === undefined) return JSON.parse(sessionStorage.getItem(k)); sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) { return null; } }
  function track(p) {
    // Only uses tracking the page already has; never loads a script.
    try {
      if (typeof window.gtag === 'function') window.gtag('event', 'size_finder_used', p);
      else if (Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({ event: 'size_finder_used' }, p));
    } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish('size_finder_used', p); } catch (e) {}
  }

  /* In-stock variants, same source and cache key as rww-stock-help.js (RW3). */
  var stockP = null;
  function inStock() {
    if (stockP) return stockP;
    var c = store('rww-instock-v1');
    if (c && c.t > Date.now() - 600000 && c.items) return (stockP = Promise.resolve(c.items));
    stockP = fetch('/collections/in-stock/products.json?limit=250', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (j) {
        var items = [];
        (j.products || []).forEach(function (p) {
          (p.variants || []).forEach(function (v) { if (v.available) items.push({ h: p.handle, v: v.id, m: v.title, c: Math.round(parseFloat(v.price) * 100) }); });
        });
        return items; // not written to RW3's 'rww-instock-v1' key: that cache has a richer shape
      }).catch(function () { stockP = null; return null; });
    return stockP;
  }
  var prodCache = {};
  function product(h) {
    if (!prodCache[h]) prodCache[h] = fetch('/products/' + h + '.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); }).catch(function () { delete prodCache[h]; return null; });
    return prodCache[h];
  }

  function init(root) {
    if (root.__rqf) return; root.__rqf = 1;
    var D; try { D = JSON.parse(root.querySelector('[data-rqf-data]').textContent); } catch (e) { return; }
    var code = function (k, v) { return (D.x[k] && D.x[k][v]) || v.replace(/[\/-]/g, ''); };
    var sizes = [], set = {};
    D.s.forEach(function (str, o) {
      for (var j = 0; j < str.length; j += 2) {
        var r = { od: D.od[o], id: D.id[parseInt(str[j], 36)], t: D.t[parseInt(str[j + 1], 36)] };
        r.h = 'rubber-washer-' + code(0, r.od) + '-od-' + code(1, r.id) + '-id-' + code(2, r.t) + '-thick';
        r.k = r.od + '|' + r.id + '|' + r.t; set[r.k] = r; sizes.push(r);
      }
    });
    var f = root.querySelector('form'), st = root.querySelector('[data-rqf-st]'), alt = root.querySelector('[data-rqf-alt]');
    var S = {}; ['od', 'id', 't', 'm'].forEach(function (k) { S[k] = f.querySelector('[data-k="' + k + '"]'); });
    var label = function (o, i, t) { return o + '" OD × ' + i + '" ID × ' + t + '"'; };

    // Preselect material on a material collection, OD on an OD collection.
    if (root.dataset.rqfMat) S.m.value = root.dataset.rqfMat;
    var oc = /^od-(\d+(?:-\d+){0,2})-rubber-washers$/.exec(root.dataset.rqfColl || '');
    if (oc) {
      var p = oc[1].split('-'), v = p.length === 1 ? p[0] : p.length === 2 ? p[0] + '/' + p[1] : p[0] + '-' + p[1] + '/' + p[2];
      if (D.od.indexOf(v) > -1) S.od.value = v;
    }

    function mark(sel, avail, base) {
      [].forEach.call(sel.options, function (op) {
        if (!op.value) return;
        var ok = avail[op.value];
        op.textContent = op.value + '"' + base + (avail.__any && !ok ? ' (request)' : '');
      });
    }
    function refreshOptions() {
      var od = S.od.value, id = S.id.value, a = {}, b = {};
      if (od) { a.__any = 1; sizes.forEach(function (r) { if (r.od === od) a[r.id] = 1; }); }
      if (od && id) { b.__any = 1; sizes.forEach(function (r) { if (r.od === od && r.id === id) b[r.t] = 1; }); }
      mark(S.id, a, ' ID'); mark(S.t, b, ' thick');
      // Only one thickness for this OD+ID: pick it.
      var bt = Object.keys(b).filter(function (k) { return k !== '__any'; });
      if (bt.length === 1 && !S.t.value) S.t.value = bt[0];
    }

    var cur = null;
    function update() {
      refreshOptions();
      alt.hidden = true; alt.innerHTML = '';
      var od = S.od.value, id = S.id.value, t = S.t.value, m = S.m.value;
      cur = null;
      if (!od || !id || !t) {
        var n = sizes.filter(function (r) { return (!od || r.od === od) && (!id || r.id === id); }).length;
        st.innerHTML = od || id ? '<b>' + n + '</b> listed size' + (n === 1 ? '' : 's') + ' match so far. Pick ' + [!od && 'OD', !id && 'ID', !t && 'thickness'].filter(Boolean).join(', ') + '.' : st.innerHTML;
        return;
      }
      if (val(id) >= val(od)) { st.innerHTML = '<span class="rqf__rq">The ID must be smaller than the OD.</span>'; return; }
      var r = set[od + '|' + id + '|' + t];
      if (!r) { st.innerHTML = '<span class="rqf__rq">' + esc(label(od, id, t)) + ' is not a listed size.</span> Tap <b>Go to washer</b> for the closest sizes or to request it.'; return; }
      cur = { r: r, v: null };
      st.innerHTML = '<span class="rqf__ok">✓ ' + esc(label(od, id, t)) + '</span> is listed. Checking stock…';
      product(r.h).then(function (p) {
        if (cur == null || cur.r !== r) return;
        if (!p) { st.innerHTML = '<span class="rqf__ok">✓ ' + esc(label(od, id, t)) + '</span> is listed.'; return; }
        var inMats = p.variants.filter(function (v) { return v.available; }).map(function (v) { return v.title; });
        var mv = m ? p.variants.filter(function (v) { return v.title === m; })[0] : null;
        cur.v = mv ? mv.id : null;
        var msg = '<span class="rqf__ok">✓ ' + esc(label(od, id, t)) + '</span> ';
        if (m) msg += mv && mv.available ? '<span class="rqf__ok">' + esc(m) + ': in stock</span>' : '<span class="rqf__rq">' + esc(m) + ': request</span>';
        if (inMats.length && !(m && mv && mv.available)) msg += (m ? ' · ' : '') + 'In stock in ' + esc(inMats.join(', '));
        else if (!inMats.length) msg += (m ? ' · ' : '') + 'All materials: request (sold out). The product page has a "Notify me" form.';
        st.innerHTML = msg;
      });
    }

    function closest(od, id, t, m) {
      var o = val(od), i = val(id), th = val(t);
      var dist = function (r) { return Math.abs(val(r.id) - i) * 3 + Math.abs(val(r.t) - th) * 6 + Math.abs(val(r.od) - o); };
      var reqUrl = '/pages/contact?rww_size=' + encodeURIComponent(label(od, id, t) + (m ? ' ' + m : ''));
      lastMiss = { od: od, id: id, thk: t, material: m || 'any' };
      var token = lastMiss;
      // Wait briefly for stock (usually already prefetched on the first select change), then render once.
      Promise.race([inStock(), new Promise(function (res) { setTimeout(function () { res(null); }, 1500); })]).then(function (items) {
        if (token !== lastMiss) return;
        var by = {};
        (items || []).forEach(function (x) { (by[x.h] = by[x.h] || []).push(x); });
        var okFor = function (r) { var v = by[r.h] || []; return m ? v.filter(function (x) { return x.m === m; })[0] : v[0]; };
        var near = sizes.slice().sort(function (a, b) { return dist(a) - dist(b); });
        var rows = near.slice(0, 3), seen = {};
        rows.forEach(function (r) { seen[r.h] = 1; });
        if (items) near.filter(function (r) { return !seen[r.h] && okFor(r); }).slice(0, 2).forEach(function (r) { rows.push(r); });
        if (rows.length < 5) near.filter(function (r) { return !seen[r.h] && rows.indexOf(r) < 0; }).slice(0, 5 - rows.length).forEach(function (r) { rows.push(r); });
        alt.innerHTML = '<b>Closest listed sizes</b><ul>' + rows.map(function (r) {
          var hit = items ? okFor(r) : null, mats = by[r.h] || [];
          var tag = !items ? '' : hit ? 'In stock' + (m ? '' : ' (' + mats.length + ' material' + (mats.length > 1 ? 's' : '') + ')') : (mats.length ? 'In stock in ' + mats[0].m : 'Request');
          var href = '/products/' + r.h + (hit && m ? '?variant=' + hit.v : '');
          return '<li><a href="' + href + '" data-h="' + r.h + '"><span>' + esc(label(r.od, r.id, r.t)) + '</span><span class="rqf__tag ' + (hit ? 'rqf__ok' : 'rqf__rq') + '">' + esc(tag) + '</span></a></li>';
        }).join('') + '</ul><a class="rqf__req" data-req href="' + reqUrl + '">Request this size: ' + esc(label(od, id, t)) + ' →</a>';
        alt.hidden = false;
      });
    }
    var lastMiss = null;
    alt.addEventListener('click', function (e) {
      var a = e.target.closest('a'); if (!a || !lastMiss) return;
      track(Object.assign({}, lastMiss, { result: a.hasAttribute('data-req') ? 'request' : 'closest' }));
    });

    f.addEventListener('change', function () { inStock(); update(); });
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var od = S.od.value, id = S.id.value, t = S.t.value, m = S.m.value;
      var miss = !od ? S.od : !id ? S.id : !t ? S.t : null;
      if (miss) { miss.focus(); st.innerHTML = '<span class="rqf__rq">Pick ' + (miss === S.od ? 'an OD' : miss === S.id ? 'an ID' : 'a thickness') + ' first.</span>'; return; }
      var r = set[od + '|' + id + '|' + t];
      if (!r) { track({ od: od, id: id, thk: t, material: m || 'any', result: 'missing' }); closest(od, id, t, m); return; }
      var go = function (vid) {
        track({ od: od, id: id, thk: t, material: m || 'any', result: 'exact' });
        location.href = '/products/' + r.h + (vid ? '?variant=' + vid : '');
      };
      if (!m) return go(null);
      var done = false, timer = setTimeout(function () { if (!done) { done = true; go(null); } }, 1200);
      product(r.h).then(function (p) {
        if (done) return; done = true; clearTimeout(timer);
        var v = p && p.variants.filter(function (x) { return x.title === m; })[0];
        go(v ? v.id : null);
      });
    });
    if (S.od.value || S.m.value) refreshOptions();
  }
  // RW12 2026-10-03 speed: building the size index used to run at DOMContentLoaded on every home/collection/page load
  // (about 250 ms of main-thread work on a throttled phone, inside the Lighthouse TBT window). Now each finder is set up
  // on its first touch, focus or change (capture phase, so the same event is handled), or when the browser is idle
  // after load. The material/OD preselect on collections stays immediate (cheap).
  function preset(root) {
    var f = root.querySelector('form'); if (!f) return;
    var m = f.querySelector('[data-k="m"]'), od = f.querySelector('[data-k="od"]');
    if (root.dataset.rqfMat && m) m.value = root.dataset.rqfMat;
    var oc = /^od-(\d+(?:-\d+){0,2})-rubber-washers$/.exec(root.dataset.rqfColl || '');
    if (oc && od) { var p = oc[1].split('-'); od.value = p.length === 1 ? p[0] : p.length === 2 ? p[0] + '/' + p[1] : p[0] + '-' + p[1] + '/' + p[2]; }
  }
  function arm(root) {
    preset(root);
    var go = function () { ['focusin', 'pointerdown', 'touchstart', 'keydown', 'change', 'input', 'submit'].forEach(function (ev) { root.removeEventListener(ev, go, true); }); init(root); };
    ['focusin', 'pointerdown', 'touchstart', 'keydown', 'change', 'input', 'submit'].forEach(function (ev) { root.addEventListener(ev, go, { capture: true, passive: ev !== 'submit' && ev !== 'keydown' }); });
    var idle = function () { (window.requestIdleCallback || function (fn) { setTimeout(fn, 200); })(function () { if (!root.__rqf) go(); }, { timeout: 4000 }); };
    if (document.readyState === 'complete') setTimeout(idle, 1500); else window.addEventListener('load', function () { setTimeout(idle, 1500); }, { once: true });
  }
  function run() { [].forEach.call(document.querySelectorAll('[data-rqf]'), arm); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
